/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { SkillFeedback, SkillFeedback$inboundSchema } from "./skillfeedback.js";

/**
 * The agent feedback a suggestion was generated from, newest first.
 */
export type ListSkillSuggestionFeedbackResult = {
  /**
   * The feedback records linked to the suggestion.
   */
  feedback: Array<SkillFeedback>;
};

/** @internal */
export const ListSkillSuggestionFeedbackResult$inboundSchema: z.ZodMiniType<
  ListSkillSuggestionFeedbackResult,
  unknown
> = z.object({
  feedback: z.array(SkillFeedback$inboundSchema),
});

export function listSkillSuggestionFeedbackResultFromJSON(
  jsonString: string,
): SafeParseResult<ListSkillSuggestionFeedbackResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListSkillSuggestionFeedbackResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListSkillSuggestionFeedbackResult' from JSON`,
  );
}
